module.exports = __webpack_public_path__ + "img/national-guard-logo.a7c7158f.jpg";